"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importDefault(require("../../Input"));
var Select_1 = __importDefault(require("../../Select"));
var Tabs_1 = require("../../Tabs/Tabs");
var errorKeys = [
    'line_1',
    'line_2',
    'town',
    'region',
    'postcode',
    'housing_tenure',
    'property_type',
    'landlord_eco',
    'property_age_band',
];
var AddressDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var _b = context_1.useSemantics(), trans = _b.trans, options = _b.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, errorKeys)); }, [errors]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.address'), subHeading: trans('optiiva::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: errors.housing_tenure, dusk: "housing-tenure-field", label: trans('optiiva::labels.housing-tenure') },
            react_1.default.createElement(Select_1.default, { width: "xs", name: "housing_tenure", options: options.housingTenures() })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.property_type, label: trans('optiiva::labels.property-type') },
            react_1.default.createElement(Select_1.default, { width: "sm", name: "property_type", options: options.propertyTypes() })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.property_age_band, label: trans('optiiva::labels.property-age') },
            react_1.default.createElement(Select_1.default, { width: "sm", name: "property_age_band", options: options.propertyAges() })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.landlord_eco, label: trans('optiiva::labels.landlord-eco'), help: trans('optiiva::help.landlord-eco') },
            react_1.default.createElement(Select_1.default, { width: "xs", name: "landlord_eco", options: options.booleanLoose() })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.line_1, dusk: "address-line-1-field", label: trans('optiiva::labels.address-line-1') },
            react_1.default.createElement(Input_1.default, { name: "line_1", maxLength: 200 })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.line_2, dusk: "address-line-2-field", label: trans('optiiva::labels.address-line-2') },
            react_1.default.createElement(Input_1.default, { name: "line_2", maxLength: 200 })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.town, dusk: "address-town-field", label: trans('optiiva::labels.address-town') },
            react_1.default.createElement(Input_1.default, { width: "sm", name: "town", maxLength: 200 })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.postcode, dusk: "address-postcode-field", label: trans('optiiva::labels.address-postcode') },
            react_1.default.createElement(Input_1.default, { width: "xs", name: "postcode", maxLength: 12 })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.region, dusk: "address-region-field", label: trans('optiiva::labels.address-region'), flush: true },
            react_1.default.createElement(Input_1.default, { width: "sm", name: "region", maxLength: 100 }))));
};
exports.default = AddressDetailsForm;
//# sourceMappingURL=AddressDetailsForm.js.map